module.exports = __webpack_public_path__ + "static/img/indexbg7.6bbd64c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/indexbg7.jpg
// module id = 1n9R
// module chunks = 1